module.exports = __webpack_public_path__ + "us.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/us.svg
// module id = 868
// module chunks = 0